// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import SurgicalSpermRetrieval from './index';
import SurgicalSpermRetrievalList from './surgicalSpermRetrievalList';
import SurgicalSpermRetrievalDetails from './surgicalSpermRetrievalDetails';
import { Permission } from '../oocyteRetrieval/OocyteRetrival.helper';

interface OocyteRetrievalFormProp {
  permissions: Permission[];
}
const SurgicalSpermRetrievalContainer: React.FC<OocyteRetrievalFormProp> = ({ permissions }) => {

  const [viewMode, setViewMode] = useState<'list' | 'edit' | 'view'>('list');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [selectedRecord, setSelectedRecord] = useState<any>(null);

  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const canEditOrAdd = permissions.some(p => p.access === 'edit' || p.access === 'add');
  const canView = permissions.some(p => p.access === 'view');
  const handleEdit = useCallback(
    (id: number) => {
      setSelectedRecord(id);
      setViewMode('edit');
      setIsEditMode(false); 
    },[]);

  const handleView = useCallback(
    (id: number) => {
      setSelectedRecord(id);
      setViewMode('view');
    },[]);

  const handleBack = useCallback(() => {
    setSelectedRecord(null);
    setViewMode('list');
    
  }, []);

  const handleEditFromView = useCallback(() => {
    setViewMode('edit');
    setIsEditMode(true); 

  }, []);

  const currentView = useMemo(() => {
    switch (viewMode) {
    case 'list':
      return (
        <SurgicalSpermRetrievalList
          onEdit={handleEdit}
          onView={handleView}
          canEditOrAdd={canEditOrAdd}
          canView={canView}
        />
      );
    case 'edit':
      return (
        selectedRecord && (
          <SurgicalSpermRetrieval
            record={selectedRecord}
            onBack={handleBack} 
            isEditMode={isEditMode}
          />
        )
      );
    case 'view':
      return (
        selectedRecord && (
          <SurgicalSpermRetrievalDetails record={selectedRecord} onBack={handleBack} onEdit={handleEditFromView} canEditOrAdd={canEditOrAdd} canView={canView}   />
        )
      );
    default:
      return null;
    }
  }, [viewMode, handleEdit, handleView, handleBack, selectedRecord, handleEditFromView, isEditMode, canEditOrAdd, canView]); // Added patientId here

  return <div>{currentView}</div>;
};

export default SurgicalSpermRetrievalContainer;
